<template>
  <b-card
    :header="header"
    class="league-stat"
  >
    <table class="prop-table">
      <tr>
        <th>Group amount</th>
        <td class="text-right">
          {{league.groupAmount | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>Participant amount</th>
        <td class="text-right">
          {{league.participantAmount | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>Participant up amount</th>
        <td class="text-right">
          {{league.participantUpAmount | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>Participant down amount</th>
        <td class="text-right">
          {{league.participantDownAmount | getFormattedNumber}}
        </td>
      </tr>
    </table>
  </b-card>
</template>

<script>
import { getEnumTmntIndividualLeagueName } from '../../autogen/bundle.js';

export default {
  name: 'LeagueStat',

  props: {
    league: {
      type: Object,
      required: true,
    },
  },

  computed: {
    header() {
      return 'Assembly ' + getEnumTmntIndividualLeagueName(this.league.id);
    },
  },
};
</script>

<style scoped>
.league-stat .card-body {
  padding: 10px;
}
</style>
